<script>
import CrudList from 'Support/components/crud/CrudList.vue';
import PayableAccountsRequest from 'Domain/financial/PayableAccountsRequest';
import DataTableDateOnlyColumn from 'Support/components/data-table/DataTableColumns/DataTableDateOnlyColumn.vue';
import DataTableCurrencyColumn from 'Support/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';

export default {
  name: 'PayableAccountsCrudList',
  extends: CrudList,
  data() {
    return {
      hideDelete: true,
      hideEdit: true,
      headers: [
        {
          text: this.$t('app.financial.payableAccounts.list.createDate'),
          value: 'dataDeGeracao',
          component: DataTableDateOnlyColumn,
        },
        {
          text: this.$t('app.financial.payableAccounts.list.origin'),
          value: 'origem',
        },
        {
          text: this.$t('app.financial.payableAccounts.list.status'),
          value: 'status',
        },
        {
          text: this.$t('app.financial.payableAccounts.list.chargeValue'),
          value: 'valor',
          component: DataTableCurrencyColumn,
        },
        {
          text: this.$t('app.financial.payableAccounts.list.description'),
          value: 'descrisao',
        },
      ],
      requestClass: PayableAccountsRequest,
    };
  },
  created() {
    this.$root.$on('refresh-crud-payable', () => {
      this.getData();
    });
  },
};
</script>
